export type Env = {
    APP_ENV: AppEnv;
    APP_VERSION: string;
    APP_IN_MEMORY?: boolean;
    STRIPE_PUBLIC_KEY: string;
    SENTRY_DSN: string;
    API_URL: string;
    ELASTIC_APM_ACTIVE?: boolean;
    ELASTIC_APM_ENVIRONMENT?: string;
    ELASTIC_APM_SERVICE_NAME?: string;
    ELASTIC_APM_SERVER_URL?: string;
};

export enum AppEnv {
    Local = 'local',
    Dev = 'dev',
    Preprod = 'preprod',
    Production = 'production',
}
